export default __webpack_public_path__ + "static/media/Highlord's Cloak of Force.e4cc4139.jpg";